const imageFragment = `#graphql
  fragment singleImage on Image {
    url
    altText
    width
    height
  }
`

export { imageFragment }
